<template>
    <div style="position: absolute;top: 0;right: 0;bottom: 0;left: 0;display: flex;flex-direction: column">
        <!-- 导航栏 -->
        <van-nav-bar title="咨询记录" left-arrow @click-left="onClickLeft" />
            <div style="padding: 10px 16px;">
                <van-row style="padding: 5px 0">
                    <van-col span="8" style="color:#777;font-size: 14px">姓名/单位</van-col>
                    <van-col span="16" style="font-size: 14px;display: flex;flex-direction: row;justify-content: start;align-items: center;">
                        <img v-if="consult.userInfo" :src="consult.userInfo.headImgUrl" width="20" style="border-radius: 10px;">
                        {{consult.userInfo.name}}
                    </van-col>
                </van-row>
                <van-row style="padding: 0">
                    <van-col span="8" style="color:#777;font-size: 14px">联系方式</van-col>
                    <van-col span="16" style="font-size: 14px">{{consult.userInfo.phone}}</van-col>
                </van-row>

                <van-row style="padding: 5px 0">
                    <van-col span="8" style="color:#777;font-size: 14px">咨询时间</van-col>
                    <van-col span="16" style="font-size: 14px">{{consult.createDate}}</van-col>
                </van-row>

                <van-row style="padding: 5px 0">
                    <van-col span="8" style="color:#777;font-size: 14px">标题</van-col>
                    <van-col span="16" style="font-size: 14px">{{consult.title}}</van-col>
                </van-row>
                <van-divider style="margin: 5px 0">咨询内容</van-divider>
                <div style="font-size: 14px; word-break:break-all">{{consult.content}}</div>
                <div>
                    <div v-for="reply in replies" :key="`reply:`+reply.id">
                        <van-divider style="margin: 5px 0">{{consultReplyTypes[reply.type]}}</van-divider>
                        <van-row style="padding: 0">
                            <van-col span="8" style="color:#777;font-size: 14px">回复人</van-col>
                            <van-col span="16" style="font-size: 14px;display: flex;flex-direction: row;justify-content: start;align-items: center;">
                                <img v-if="reply.userInfo" :src="reply.userInfo.headImgUrl" width="20" style="border-radius: 10px;">
                                {{reply.userInfo?reply.userInfo.name:''}}
                            </van-col>
                        </van-row>

                        <van-row style="padding: 5px 0">
                            <van-col span="8" style="color:#777;font-size: 14px">回复时间</van-col>
                            <van-col span="16" style="font-size: 14px">{{reply.createDate}}</van-col>
                        </van-row>
                        <div style="font-size: 14px; word-break:break-all">{{reply.content}}</div>
                    </div>

<!--                    被关闭的任务不可回复或追问-->
                    <van-divider  v-if="consult.state===consultStatus.finished">
                        该问题已经被关闭，不能再追问或者回复
                    </van-divider>
                    <div v-else >
<!--                        判断当前用户是否可回复此问题-->
                        <div v-if="isConsultCanReply.flag">
                            <van-divider/>
                            <van-field
                                    v-model="message"
                                    type="textarea"
                                    placeholder="请输入回复内容"
                                    rows="5"
                                    maxlength="300"
                                    autosize
                                    style="border: 1px solid #ebedf0;border-radius: 5px;margin:5px 0"
                                    show-word-limit
                            ></van-field>
                            <van-checkbox style="float: left" v-if="userType === userTypes.lawyer " v-model="isCloseConsult" shape="square">同时关闭咨询</van-checkbox>
                            <van-button  slot="button" style="float: right" size="small" type="primary" @click="addReply(consult)">{{userType===userTypes.lawyer?'回复':'追问'}}</van-button>
                        </div>
                        <van-divider  v-else>{{isConsultCanReply.msg}}</van-divider >
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
  import {Dialog,Toast} from 'vant';
  import axios from '../../common/axios';
  import {responseCodes,consultReplyTypes,userTypes,consultStatus} from '../../common/const'

  export default {
    name: "ConsultHistory.vue",
    data() {
      return {
        consultReplyTypes,
        responseCodes,
        userTypes,
        consultStatus,
        isCloseConsult:true,
        message:'',
        replies:[]
      };
    },
    computed:{
      consult(){
        return this.$route.params.item
      },
      userType(){
        return this.$route.params.userType
      },
      isConsultCanReply(){
        let result={
          flag:false,
          msg:'',
        }

        //普通用户只能追问
        if (this.userType === userTypes.customer){
          if (this.getLastReplyType(this.replies)===consultReplyTypes.reply){
            result.flag = true;
          } else {
            result.flag = false;
            result.msg = '正在等待律师回复'
          }
          //律师可以回复问题并且可以多次回复
        } else {
          if (this.getLastReplyType(this.replies)!==consultReplyTypes.finallyReply) {
            result.flag = true;
          }else{
            result.flag = false;
            result.msg = '咨询已结束'
          }
        }
        return result;
      }
    },
    mounted(){
      this.loadReply();
    },
    methods: {
      async loadReply(){
        let body = {
          consultId:this.consult.id
        }
        try {
          let response = await axios.post(`/fyserve/consult/getConsultReplied/v2?page=1&size=100`,body)
          let data = response.data;
          if (data.code === responseCodes.success) {
            console.info(data.data)
            this.replies.push(...data.data)
          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
          Toast.fail("加载回复数据失败")
        }
      },


      onClickLeft() {
        this.$router.back();
      },



      getLastReplyType(consultReplieds){
        console.info('-------------------')
        let length = consultReplieds.length;
        if(length===0) {
          return -1
        }
        return consultReplieds[length-1].type;
      },

      async addReply(consult){
        this.message = this.message.trim();
        if (this.message.length===0) {
          Dialog.alert({
            message: `请输入${this.userType===userTypes.lawyer?'回复':'追问'}内容`
          }).then(() => {
            // on close
          });
          return
        }
        let type  = consultReplyTypes.asked

        if(this.userType===userTypes.customer){
          type  = consultReplyTypes.asked
        }else {
          if(this.isCloseConsult){
            type  = consultReplyTypes.finallyReply
          }else {
            type  = consultReplyTypes.reply
          }
        }



        let reply = {
          openId:this.$store.state.user.openId,
          content:this.message,
          consultId:consult.id,
          type
        }

        this.$store.commit("showOverlay")
        try {
          let response = await axios.post("/fyserve/consult/addReplied/v2" ,reply)
          let data = response.data;
          if (data.code === responseCodes.success) {
            this.replies.push(data.data)
          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
          Toast.fail("加载数据失败")
        }
        this.$store.commit("hideOverlay")
        this.message = '';
        this.isCloseConsult = false

      }
    }
  }
</script>

<style scoped>
    .van-cell__title{
        font-size: 16px;
        flex: 3;
    }
    .van-cell:not(:last-child)::after{
        right: 16px;
    }
    .van-field__value::after{
        border: none;
    }
</style>